export const maxPrinterCount = 2
